import { 
    ACHIEVEMENT_CATEGORY_LIST_FAIL,
    ACHIEVEMENT_CATEGORY_LIST_REQUEST,
    ACHIEVEMENT_CATEGORY_LIST_SUCCESS,
    ACHIEVEMENT_EVENT_LIST_FAIL,
    ACHIEVEMENT_EVENT_LIST_REQUEST,
    ACHIEVEMENT_EVENT_LIST_SUCCESS,
    ACHIEVEMENT_EVENT_LIST_ALL_SUCCESS
} from '../constants/achievementConstants'
import axios from 'axios'
import { message } from 'antd'

export const listEvent = (page, search) => async (dispatch) => {
  try {
    dispatch({
      type: ACHIEVEMENT_EVENT_LIST_REQUEST,
    })

    const { data } = await axios.get(`achievements/getEvents`, {
      params: {
        'page' : page,
        'search': search
      }
    })

    dispatch({
      type: ACHIEVEMENT_EVENT_LIST_SUCCESS,
      payload: data
    })
  } catch (e) {
    const err = e.response && e.response.data.message ? e.response.data.message : e.message;
    dispatch({
      type: ACHIEVEMENT_EVENT_LIST_FAIL,
      payload: err          
    })
  }
}

export const listAllEvents = () => async (dispatch) => {
  try {
    dispatch({
      type: ACHIEVEMENT_EVENT_LIST_REQUEST,
    })

    const { data } = await axios.get(`achievements/getAllEvents`)

    dispatch({
      type: ACHIEVEMENT_EVENT_LIST_ALL_SUCCESS,
      payload: data
    })
  } catch (e) {
    const err = e.response && e.response.data.message ? e.response.data.message : e.message;
    dispatch({
      type: ACHIEVEMENT_EVENT_LIST_FAIL,
      payload: err          
    })
  }
}

export const createEvent = (name, history) => async () => {
  message.loading('Loading...', "updatable");
  try {
    await axios.post(`achievements/createEvent`, { name })
    message.success({
      content: 'Successfully Created Event',
      key: 'updatable'
    });
    history.push('/event-index')
  } catch (e) {
    const err = e.response && e.response.data.message ? e.response.data.message : e.message;
    message.error({content: `Failed to Create Event: ${err}`, key: "updatable"});
  }
}

export const deleteEvent = (id) => async () => {
  message.loading('Loading...', "updatable");
  try {
    await axios.delete(`achievements/deleteEvent/${id}`)
    message.success({
      content: 'Successfully Deleted Event',
      key: 'updatable'
    });
  } catch (e) {
    const err = e.response && e.response.data.message ? e.response.data.message : e.message;
    message.error({content: `Failed to Delete Event: ${err}`, key: "updatable"});
  }
}

export const updateEvent = (history, id, name) => async () => {
  message.loading('Loading...', "updatable");
  try {
    await axios.put(`achievements/updateEvent/${id}`, {name})
    message.success({
      content: 'Successfully Deleted Event',
      key: 'updatable'
    });
    history.push('/event-index')
  } catch (e) {
    const err = e.response && e.response.data.message ? e.response.data.message : e.message;
    message.error({content: `Failed to Delete Event: ${err}`, key: "updatable"});
  }
}

export const listCategory = (page, search, event) => async (dispatch) => {
  try {
    dispatch({
      type: ACHIEVEMENT_CATEGORY_LIST_REQUEST,
    })

    const { data } = await axios.get(`achievements/getCategories`, {
      params: {
        page, search, event
      }
    })

    dispatch({
      type: ACHIEVEMENT_CATEGORY_LIST_SUCCESS,
      payload: data
    })
  } catch (e) {
    const err = e.response && e.response.data.message ? e.response.data.message : e.message;
    dispatch({
      type: ACHIEVEMENT_CATEGORY_LIST_FAIL,
      payload: err          
    })
  }
}

export const createCategory = (name, id, history) => async () => {
  message.loading('Loading...', "updatable");
  try {
    await axios.post(`achievements/createCategory`, { name, id })
    message.success({
      content: 'Successfully Created Category',
      key: 'updatable'
    });
    history.push('/category-index')
  } catch (e) {
    const err = e.response && e.response.data.message ? e.response.data.message : e.message;
    message.error({content: `Failed to Create Category: ${err}`, key: "updatable"});
  }
}

export const deleteCategory = (id) => async () => {
  message.loading('Loading...', "updatable");
  try {
    await axios.delete(`achievements/deleteCategory/${id}`)
    message.success({
      content: 'Successfully Deleted Category',
      key: 'updatable'
    });
  } catch (e) {
    const err = e.response && e.response.data.message ? e.response.data.message : e.message;
    message.error({content: `Failed to Delete Category: ${err}`, key: "updatable"});
  }
}

export const updateCategory = (history, id, name, event_id) => async () => {
  message.loading('Loading...', "updatable");
  try {
    await axios.put(`achievements/updateCategory/${id}`, {name, event_id})
    message.success({
      content: 'Successfully Deleted Category',
      key: 'updatable'
    });
    history.push('/category-index')
  } catch (e) {
    const err = e.response && e.response.data.message ? e.response.data.message : e.message;
    message.error({content: `Failed to Delete Category: ${err}`, key: "updatable"});
  }
}
